import { render, staticRenderFns } from "./FactMatchPlayer.vue?vue&type=template&id=35af6ee8&scoped=true&"
import script from "./FactMatchPlayer.vue?vue&type=script&lang=js&"
export * from "./FactMatchPlayer.vue?vue&type=script&lang=js&"
import style0 from "./FactMatchPlayer.vue?vue&type=style&index=0&id=35af6ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af6ee8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35af6ee8')) {
      api.createRecord('35af6ee8', component.options)
    } else {
      api.reload('35af6ee8', component.options)
    }
    module.hot.accept("./FactMatchPlayer.vue?vue&type=template&id=35af6ee8&scoped=true&", function () {
      api.rerender('35af6ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Player/FactMatchPlayer.vue"
export default component.exports